export default __webpack_public_path__ + "static/media/business-288a.fb79ae7a.jpg";